import { useEffect, useRef, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Alert,
  useMediaQuery,
  Tooltip,
  IconButton,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

import { useAuthContext } from '../../context/auth';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useDialogStyles from '../../hooks/useDialogStyles';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useApplicationTypeContext } from '../../context/appType';

const validator = require('validator');

const EditAppType = ({id, name}) => {

  const axiosPrivate = useAxiosPrivate();
  const { dispatchAppType } = useApplicationTypeContext();
  const { auth } = useAuthContext();
  const ds = useDialogStyles();

  const closeDialog = () => { setShow(false); setError(null); };

  const [error, setError] = useState(null);
  const [show, setShow] = useState(false);

  const nameRef = useRef('');

  const handleEdit = async () => {
    const updateAppType = {
      name: nameRef.current.value,
    };

    const prevAppType = [name];

    Object.keys(updateAppType).forEach((key) => {
      if (
        validator.isEmpty(updateAppType[key]?.toString() || '', { ignore_whitespace: true }) ||
        prevAppType.includes(updateAppType[key])
      ) {
        delete updateAppType[key];
      }
    });
    
    if (!auth) {
      setError('You must be logged in');
      return;
    }

    const checkChange = Object.keys(updateAppType).length === 0;

    if (!checkChange) {
      updateAppType.id = id;

      try {
        const response = await axiosPrivate.patch(
          '/api/appTypes', updateAppType
        );

        dispatchAppType({ type: 'UPDATE_APPLICATION_TYPE', payload: response.data });
        setError(null);
        setShow(false);
      } catch (error) {
        setError(error.response?.data.error || 'Upload failed');
      } 
    } else {
      setError('Nothing Changed');
    }
  };

  return (
    <>
      <Tooltip title="Edit AppType">
        <IconButton
          color="secondary"
          size="small"
          style={{ marginRight: 8 }}
          onClick={() => setShow(true)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>

      <Dialog open={show} onClose={closeDialog} fullWidth maxWidth="xs" PaperProps={{ sx: ds.paperSx }}>
        <DialogTitle sx={ds.titleSx}>Edit application type</DialogTitle>

        <DialogContent sx={ds.contentSx}>
          <TextField
            fullWidth
            label="Name"
            inputRef={nameRef}
            variant="outlined"
            autoComplete="off"
            defaultValue={name}
            sx={ds.fieldSx}
          />

          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}
        </DialogContent>

        <DialogActions sx={ds.actionsSx}>
          <Button onClick={closeDialog} sx={ds.cancelButtonSx}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleEdit} sx={ds.goldButtonSx}>
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditAppType;
